(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tf-shipping-upgrade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-shipping-upgrade')) {
  customElements.define('tf-shipping-upgrade', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.busy = false;
      this.scope = this.closest('[data-tf-hub]') || document;
      this.scope.querySelectorAll('[data-tf-upgrade-open]').forEach(button => button.addEventListener('click', () => {
        this.opener = button;
        if (this.busy) this.dialog.show();
        else this.dialog.showModal();
        this.querySelector('[data-tf-upgrade-result], input:not([type="hidden"])')?.focus();
      }, options));
      this.querySelectorAll('[data-tf-upgrade-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('close', () => { if (!this.busy) this.opener?.focus(); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.form?.addEventListener('change', () => this.updateCost(), options);
      this.form?.addEventListener('submit', event => {
        if (this.busy) { event.preventDefault(); return; }
        if (!this.form.reportValidity()) { event.preventDefault(); return; }
        this.updateCost();
        if (this.form.hasAttribute('data-tf-local-preview')) {
          event.preventDefault();
          this.showError(this.querySelector('[data-tf-upgrade-preview-message]').textContent);
          return;
        }
        if (!navigator.onLine) {
          event.preventDefault();
          this.showError(this.querySelector('[data-tf-upgrade-offline]').textContent);
          return;
        }
        event.preventDefault();
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.submitButton.dataset.busyLabel;
        this.querySelector('[data-tf-upgrade-status]').textContent = this.submitButton.dataset.busyLabel;
        this.timer = setTimeout(() => {
          this.showError(this.querySelector('[data-tf-upgrade-unconfirmed]').textContent);
        }, 45000);


        let submitted = false;
        const send = () => {
          if (submitted || !this.isConnected) return;
          submitted = true;
          this.form.submit();
        };
        if (window.Shopify?.captcha?.protect) {



          this.dialog.classList.add('tf-upgrade-verifying');
          this.dialog.close();
          this.dialog.show();
          window.Shopify.captcha.protect(this.form, send);
        }
        else send();
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted && this.submitButton) {
          this.busy = false;
          this.dialog.classList.remove('tf-upgrade-verifying');
          this.form.removeAttribute('aria-busy');
          this.submitButton.disabled = false;
          this.submitButton.textContent = this.submitButton.dataset.idleLabel;
          this.querySelector('[data-tf-upgrade-status]').textContent = '';
          clearTimeout(this.timer);
        }
      }, options);
      const result = this.querySelector('[data-tf-upgrade-result]');
      if (result || location.hash === '#tf-upgrade-dialog') {
        this.dialog.showModal();
        (result || this.querySelector('input:not([type="hidden"])'))?.focus();
      }
      this.updateCost();
    }
    updateCost() {
      const chosen = this.querySelector('input[type="radio"]:checked');
      if (!chosen) return;
      this.querySelector('[data-tf-upgrade-total]').textContent = '+$' + chosen.dataset.cost + ' USD';
      this.querySelector('[data-tf-upgrade-cost]').value = chosen.dataset.cost;
    }
    showError(message) {
      const error = this.querySelector('[data-tf-upgrade-client-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
      error.focus();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tf-video-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tf-video-categories')) {
    customElements.define('tf-video-categories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tf-filters');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('.tf-category-arrow');
          if (!button || button.disabled) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: Number(button.dataset.direction) * direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
        const revealCurrent = () => {
          if (!this.isConnected) return;
          const active = this.track.querySelector('[aria-current="page"]');
          if (active) {
            const item = active.getBoundingClientRect(), track = this.track.getBoundingClientRect();
            if (item.left < track.left) this.track.scrollBy({ left: item.left - track.left, behavior: 'auto' });
            else if (item.right > track.right) this.track.scrollBy({ left: item.right - track.right, behavior: 'auto' });
          }
          this.update();
        };
        if (document.fonts) document.fonts.ready.then(revealCurrent);
        else revealCurrent();
      }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const position = Math.max(0, Math.min(max, this.track.scrollLeft * direction));
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
      }
      disconnectedCallback() { this.abort.abort(); this.resize.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
